import React, { useState, useEffect, useRef } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import AutoComplete from '../../../utils/components/AutoComplete';
import { Spacer } from '../../../utils/components/Spacer';

type Props = {
  setSearchConditionRequestPointName: (requestPointName?: string[]) => void;
  requestPointNameList: string[];
  setSearchConditionRequestPointId: (requestPointId?: string[]) => void;
  requestPointIdList: string[];
  setSearchConditionSupplyPointNo: (supplyPointNo?: string[]) => void;
  supplyPointNoList: string[];
  setSearchConditionAddress: (address?: string[]) => void;
  addressList: string[];
  setSearchConditionFeeMenuNamePrinting: (feeMenuNamePrinting?: string[]) => void;
  setSearchConditionVoltageClass: (low?: boolean, high?: boolean, exHigh?: boolean) => void;
  setSearchConditionSupplyDate: (startHead: Dayjs|null, startTail: Dayjs|null, EndHead: Dayjs|null, EndTail: Dayjs|null) => void;
  feeMenuNamePrintingList: string[];
  resetData: () => void;
}

export default function SearchBoxSettingElectricityAlarm(props: Props) {
  const [open, setOpen] = useState(false);
  const [pointName, setPointName] = useState<string[]>([]);
  const [pointId, setPointId] = useState<string[]>([]);
  const [address, setAddress] = useState<string[]>([]);
  const [supplyPointNo, setSupplyPointNo] = useState<string[]>([]);
  const [feeMenuNamePrinting, setFeeMenuNamePrinting] = useState<string[]>([]);
  // チェックボックス3つ分
  const [checkedLow, setCheckedLow] = useState(true);
  const [checkedHigh, setCheckedHigh] = useState(true);
  const [checkedExHigh, setCheckedExHigh] = useState(true);
  // カレンダー検索ボックス
  const [supplyStartDateHead, setSupplyStartDateHead] = useState<Dayjs | null>(null);
  const [supplyStartDateTail, setSupplyStartDateTail] = useState<Dayjs | null>(null);
  const [supplyEndDateHead, setSupplyEndDateHead] = useState<Dayjs | null>(dayjs());
  const [supplyEndDateTail, setSupplyEndDateTail] = useState<Dayjs | null>(null);
  
  const {
    setSearchConditionRequestPointName,
    requestPointNameList, 
    setSearchConditionRequestPointId,
    requestPointIdList,
    setSearchConditionSupplyPointNo,
    supplyPointNoList,
    setSearchConditionAddress,
    addressList,
    setSearchConditionFeeMenuNamePrinting,
    feeMenuNamePrintingList,
    setSearchConditionVoltageClass,
    setSearchConditionSupplyDate,
    resetData
  } = props;

  const handleClick = () => {
    setOpen(!open);
  };
  
  useEffect(() => {
    setSearchConditionVoltageClass(checkedExHigh, checkedHigh, checkedLow);
  }, [checkedExHigh, checkedHigh, checkedLow])
  
  const handleChangeLow = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedLow(event.target.checked);
  };
  const handleChangeHigh = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedHigh(event.target.checked);
  };
  const handleChangeExHigh = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedExHigh(event.target.checked);
  };
  
  const handleChangeSupplyStartHead = (newValue: Dayjs | null) => {
     setSupplyStartDateHead(newValue);
     setSearchConditionSupplyDate(newValue, null, null, null);
  };
  const handleChangeSupplyStartTail = (newValue: Dayjs | null) => {
     setSupplyStartDateTail(newValue);
     setSearchConditionSupplyDate(null, newValue, null, null);
  };
  const handleChangeSupplyEndHead = (newValue: Dayjs | null) => {
     setSupplyEndDateHead(newValue);
     setSearchConditionSupplyDate(null, null, newValue, null);
  };
  const handleChangeSupplyEndTail = (newValue: Dayjs | null) => {
     setSupplyEndDateTail(newValue);
     setSearchConditionSupplyDate(null, null, null, newValue);
  };
  
  const resetConditionOnClick = () => {
    setPointName([]);
    setPointId([]);
    setAddress([]);
    setSupplyPointNo([]);
    setFeeMenuNamePrinting([]);
    setCheckedLow(true);
    setCheckedHigh(true);
    setCheckedExHigh(true);
    setSupplyStartDateHead(null);
    setSupplyStartDateTail(null);
    setSupplyEndDateHead(dayjs());
    setSupplyEndDateTail(null);
    resetData();
  };

  return (
    <div>
      <ListItemButton sx={{ bgcolor: '#0099CC', color: '#ffffff' }} onClick={handleClick}>
        {open ? <ExpandLess /> : <ExpandMore />}
        <ListItemText primary="詳細絞り込み" />
      </ListItemButton>
      {open &&
        <Paper sx={{ height: 400 }} variant="outlined" square >
          <Spacer size={10} />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8}>
              <Typography variant="body1">需要場所</Typography>
              <AutoComplete
                value={pointName}
                setValue={setPointName}
                requestList={requestPointNameList}
                setSearchConditionRequest={setSearchConditionRequestPointName}/>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body1">需要場所ID</Typography>
              <AutoComplete
                value={pointId}
                setValue={setPointId}
                requestList={requestPointIdList}
                setSearchConditionRequest={setSearchConditionRequestPointId}/>
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8}>
              <Typography variant="body1">住所</Typography>
              <AutoComplete
                value={address}
                setValue={setAddress}
                requestList={addressList}
                setSearchConditionRequest={setSearchConditionAddress}/>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body1">供給地点特定番号</Typography>
              <AutoComplete
                value={supplyPointNo}
                setValue={setSupplyPointNo}
                requestList={supplyPointNoList}
                setSearchConditionRequest={setSearchConditionSupplyPointNo}/>
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8}>
              <Typography variant="body1">契約種別</Typography>
              <AutoComplete
                value={feeMenuNamePrinting}
                setValue={setFeeMenuNamePrinting}
                requestList={feeMenuNamePrintingList}
                setSearchConditionRequest={setSearchConditionFeeMenuNamePrinting}/>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body1">電圧区分</Typography>
              <Stack direction="row" spacing={1}>
                <FormControlLabel control={<Checkbox checked={checkedExHigh} onChange={handleChangeExHigh} />} label="特高" />
                <FormControlLabel control={<Checkbox checked={checkedHigh} onChange={handleChangeHigh} />} label="高圧" />
                <FormControlLabel control={<Checkbox checked={checkedLow} onChange={handleChangeLow} />} label="低圧" />
              </Stack>
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={4}>
              <Typography variant="body1">供給開始日</Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={5.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ja'>
                    <DateTimePicker
                     value={supplyStartDateHead}
                     format="YYYY/MM/DD"
                     slotProps={{ textField: { size: 'small'}}}
                     onChange={handleChangeSupplyStartHead}
                     views={['year', 'month', 'day']}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant="body1">~</Typography>
                </Grid>
                <Grid item xs={5.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ja'>
                    <DateTimePicker
                     value={supplyStartDateTail}
                     format="YYYY/MM/DD"
                     slotProps={{ textField: { size: 'small'}}}
                     onChange={handleChangeSupplyStartTail}
                     views={['year', 'month', 'day']}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1">供給終了日</Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={5.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ja'>
                    <DateTimePicker
                     value={supplyEndDateHead}
                     format="YYYY/MM/DD"
                     slotProps={{ textField: { size: 'small'}}}
                     onChange={handleChangeSupplyEndHead}
                     views={['year', 'month', 'day']}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={1}>
                  <Typography variant="body1">~</Typography>
                </Grid>
                <Grid item xs={5.5}>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ja'>
                    <DateTimePicker
                     value={supplyEndDateTail}
                     format="YYYY/MM/DD"
                     slotProps={{ textField: { size: 'small'}}}
                     onChange={handleChangeSupplyEndTail}
                     views={['year', 'month', 'day']}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8.5}></Grid>
            <Grid item xs={3}>
              <Box display="flex" justifyContent="flex-end">
                <Button variant="text" onClick={resetConditionOnClick}>検索条件をクリア</Button>
              </Box>
            </Grid>
            <Grid item xs={0.5}></Grid>
          </Grid>
        </Paper>
      }
    </div>
  );
}